import {Component, Inject, OnInit} from '@angular/core';
import {FormBuilder, FormControl, FormGroup, FormGroupDirective, NgForm, Validators} from '@angular/forms';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import { DateAdapter } from '@angular/material/core';
import { ErrorStateMatcher } from '@angular/material/core';
import * as ClassicEditor from '@ckeditor/ckeditor5-build-classic';

/** Error when invalid control is dirty, touched, or submitted. */
export class FormErrorStateMatcher implements ErrorStateMatcher {
  isErrorState (control: FormControl | null, form: FormGroupDirective | NgForm | null): boolean {
    const isSubmitted = form && form.submitted;
    return !!(control && control.invalid && (control.dirty || control.touched || isSubmitted));
  }
}

@Component({
  selector: 'app-annuity-letter-dialog',
  templateUrl: './annuity-letter-dialog.component.html',
  styleUrls: [ './annuity-letter-dialog.component.scss' ]
})
export class AnnuityLetterDialogComponent implements OnInit {

  public matcher = new FormErrorStateMatcher();

  public letter: any;
  public entityForm: FormGroup;

  public objectImage: any = null;
  public storedImage: any;

  public isEdit: boolean;

  public Editor = ClassicEditor;

  constructor (
    private fb: FormBuilder,
    private _adapter: DateAdapter<any>,
    public matDialogRef: MatDialogRef<AnnuityLetterDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.letter = this.data;

    if (this.letter.id === "0")
      this.isEdit = false
    else
      this.isEdit = true
  }

  ngOnInit () {
    this._adapter.setLocale('pt');
    this.entityForm = this.createForm(this.letter)
  }

  createForm (data: any) {
    let form: FormGroup = this.fb.group({
      id: new FormControl(data.id),
      annuity_id: new FormControl(data.annuity_id, [ Validators.required ]),
      name: new FormControl(data.name, [ Validators.required ]),
      subject: new FormControl(data.subject, [ Validators.required ]),
      text: new FormControl(data.text, [ Validators.required ]),
      image: new FormControl(data.image || ""),
      created: new FormControl(data.created),
      deleted: new FormControl(false),
    });

    this.storedImage = data.image;

    return form
  }

  previewImage (event) {

    if (event.target.files.length === 0)
      return;

    var mimeType = event.target.files[ 0 ].type;
    if (mimeType.match(/image\/*/) == null) {
      return;
    }

    var reader = new FileReader();
    this.objectImage = event.target.files[ 0 ];
    reader.readAsDataURL(event.target.files[ 0 ]);
    reader.onload = (_event) => {
      this.storedImage = reader.result;
      return event.target.files[ 0 ];
    }
  }


}
